import OfficialDiaryAppService from "../../../../application/platform/official-daily/official-daily-app-service";
import { ACTION_TYPES, useDetalhesDiarioOficialDispatch } from "./detalhes-diario-oficial-context";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";

export const useDetalhesDiarioOficialController = () => {
    const detalhesDiarioOficialDispatch = useDetalhesDiarioOficialDispatch();
    const { showBackDrop } = useBaseLayoutController();

    const loadData = async (officialDailyId: number) => {
        showBackDrop(true);
        const data = await OfficialDiaryAppService.getById(Number(officialDailyId));
        detalhesDiarioOficialDispatch({
            type: ACTION_TYPES.setOfficialDiaryDetailResponse,
            payload: data,
        });
      
        showBackDrop(false);
    }

    return { loadData }
}